export const SET_WALLBOARD = 'SET_WALLBOARD'
export const RESET_WALLBOARD = 'RESET_WALLBOARD'
